import React from 'react';
import Helmet from 'react-helmet';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Navbar from './navbar';
import Footer from './Footer';
import Breadcrumbs from './breadcrumbs';
import '../all.scss';
var siteName = 'Divritenis.lv';

var Layout = function Layout(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      title = _ref.title,
      children = _ref.children;
  var siteTitle = title === undefined || title === null ? siteName : siteName + " | " + title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoogleReCaptchaProvider, {
    reCaptchaKey: process.env.GATSBY_RECAPTCHA_SITE_KEY,
    language: "lv"
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: siteTitle
  }), /*#__PURE__*/React.createElement(Navbar, null), /*#__PURE__*/React.createElement("div", {
    className: "section"
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    pageKeys: breadcrumbs !== null && breadcrumbs !== void 0 ? breadcrumbs : []
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, children)), /*#__PURE__*/React.createElement(Footer, null)));
};

export default Layout;